<template>
  <div class="need-attention">
    <div style="border-bottom:1px solid #333;">
      <Select dbref="MST.SelBalai" :value.sync="balaiId" width="500px" />
    </div>
    <div
      style="padding:10px; height:calc(100vh - 155px); overflow:auto; background:rgba(255,255,255,1)"
    >
      <List
        dbref="DOC.SelNeedAttention"
        :dbparams="{ BalaiID: balaiId, Tahun: tahun }"
        :items.sync="items"
      >
        <template v-slot="{ row }">
          <div style="padding:10px; margin-top:2px; font-size:small;">
            <div style="display: flex;">
              <div style="flex: 2;">
                <a :href="row.Url.replace(/#/, '')">{{ row.Topic }}</a>
              </div>
              <div style="flex: 1; text-align: right;">
                <span
                  style="font-weight:bold; font-size:12px;"
                  :class="row.Title.replace(/\s/g, '-')"
                >
                  <i :class="row.Icon"></i> &nbsp;{{ row.Title }}</span
                >
                <div style="color:Gray;">{{ row.Desc }}</div>
              </div>
            </div>
            <div style="padding-bottom: 3px;">
              <v-btn text dense small v-show="false" style="float: right;">
                [+] Arahan
              </v-btn>
              <i class="fa fa-quote-right"></i> {{ row.Arahan }}
            </div>
            <div style="display: flex;">
              <div
                class="step"
                :style="{
                  opacity: row.DiffPJ == null ? '0.5' : '1',
                  background: row.DiffPJ > 1 ? ':red' : '',
                }"
              >
                PJ : {{ row.DiffPJ > 0 ? 1 : row.DiffPJ }} Hari
              </div>
              <div
                class="step"
                :style="{
                  opacity: row.DiffKonsultan == null ? '0.5' : '1',
                }"
              >
                KONS : {{ row.DiffKonsultan }} Hari
              </div>
              <div
                class="step"
                :style="{
                  opacity: row.DiffST == null ? '0.5' : '1',
                }"
              >
                ST : {{ row.DiffST }} Hari
              </div>
              <div
                class="step"
                :style="{
                  opacity: row.DiffPPHP == null ? '0.5' : '1',
                  background: row.DiffPPHP > 1 ? ':red' : '',
                }"
              >
                PPHP : {{ row.DiffPPHP }} Hari
              </div>
              <div
                class="step"
                :style="{
                  opacity: row.DiffKPA == null ? '0.5' : '1',
                }"
              >
                KPA : {{ row.DiffKPA }} Hari
              </div>
              <div
                class="step"
                :style="{
                  opacity: row.DiffBPP == null ? '0.5' : '1',
                }"
              >
                B PP : {{ row.DiffBPP }} Hari
              </div>
            </div>
          </div>
        </template>
      </List>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    items: [],
    tahun: localStorage.getItem('tahun'),
    balaiId: localStorage.getItem('balaiId'),
  }),
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
  watch: {
    items(val) {
      if (val.length) {
        this.headers = [
          { Title: null, Total: 0 },
          { Title: null, Total: 0 },
          { Title: null, Total: 0 },
          { Title: null, Total: 0 },
          { Title: null, Total: 0 },
          { Title: null, Total: 0 },
        ]

        val.forEach(d => {
          this.headers[0].Title = d.Title0
          this.headers[0].Total += d.Verification0
          this.headers[1].Title = d.Title1
          this.headers[1].Total += d.Verification1
          this.headers[2].Title = d.Title2
          this.headers[2].Total += d.Verification2
          this.headers[3].Title = d.Title3
          this.headers[3].Total += d.Verification3
          this.headers[4].Title = d.Title4
          this.headers[4].Total += d.Verification4
          this.headers[5].Title = d.Title5
          this.headers[5].Total += d.Verification5
        })
      }
    },
  },
}
</script>
<style lang="scss">
.hide {
  display: none;
}
.need-attention {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  a {
    text-decoration: none;
    font-family: 'Montserrat';
    font-weight: bold;
    color: #34495e !important;
  }
  .step {
    flex: 1;
    margin: 0 2px;
    font-size: smaller;
    padding: 3px 5px;
    background-color: cadetblue;
    color: white;
    border-radius: 3px;
    line-height: 12px;
  }
  .SUDAH-JATUH-TEMPO {
    background-color: #ff8a65;
    color: white;
    padding: 3px 5px;
    border-radius: 3px;
  }
  .HAMPIR-JATUH-TEMPO {
    background-color: #ffd54f;
    color: #333;
    padding: 3px 5px;
    border-radius: 3px;
  }
}
</style>
